// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {Checkbox, FormHelperText, Input, InputLabel, Select, Stack} from "@mui/material";

// App Imports
import {addDataPoint, editDataPoint} from "./DataPointClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {changeDataPoint} from "./dataPointSlice";
import {addDataPointAttribute} from "../DataPointAttribute/DataPointAttributeClient";



// Main Function
export default function DataPointDrawer(fetchDataPoints) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.id);
    const selectorDpDrawerState = useSelector((state) => state.dataPointSlc.value.dpDrawerState);
    const selectorDpDrawerMode = useSelector((state) => state.dataPointSlc.value.dpDrawerMode);
    const [allowMany, setAllowMany] = useState(useSelector((state) => state.dataPointSlc.value.allowMany));

    
    // ****************** END STORE ****************************

    // ****************** BEGIN SELECTORS ****************************

    // ****************** END SELECTORS ****************************


    // ****************** BEGIN CLOSE ***************************
    function closeDataPointDrawer() {
        dispatchData(changeDataPoint({dpDrawerState: false }));
    };
// ******************** END CLOSE ********************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my dataPoint data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorDpDrawerMode==="Add"){
            addDataPoint(data)
                .then(() => {
                    console.log("DataPoint added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                    // fetchDataPoints();
                }).catch(err => {
                    console.log("error in addDataPoint");
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPoint({dpDrawerState: false, dpGridRefresh: true }));
            })}
        if(selectorDpDrawerMode==="Clone"){
            const { id, ...clonedData } = data; // removes id
            addDataPoint(clonedData)
                .then(() => {
                    console.log("DataPoint added");
                    // fetchDataPoints();
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Clone failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPoint({dpDrawerState: false, dpGridRefresh: true }));
            })}
        if(selectorDpDrawerMode==="Edit"){
            console.log("This is the dataPoint Id I am going to edit")
            console.log(selectorDataPointId)
            editDataPoint(selectorDataPointId, data)
                .then(() => {
                    console.log("DataPoint edited")
                    // fetchDataPoints();
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeDataPoint({dpDrawerState: false, dpGridRefresh: true }));
            })}
    };

    // ****************** END CRUD ****************************


    // ****************** BEGIN MISC ****************************

    // ****************** END MISC ****************************


    const [dataType, setDataType] = useState([]);
    const [selectedDataType, setSelectedDataType] = useState([]);
    const [piiClassification, setPiiClassification] = useState([]);
    const [selectedPiiClassification, setSelectedPiiClassification] = useState([]);


    const fetchDropdownLists = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                setDataType(data.filter(data => data.dataPointId ===  2337));
                setPiiClassification(data.filter(data => data.dataPointId ===  4781));
            })
    useEffect(() => {
        fetchDropdownLists();
    }, []);
    //
    const handleDataTypeChange = (dataTypeEvent) => {
        setSelectedDataType(dataTypeEvent.target.value);
        console.log("This is for the selected data types");
        console.log(dataTypeEvent.target.value);
    };

    const handlePiiClassificationChange = (piiClassificationEvent) => {
        setSelectedPiiClassification(piiClassificationEvent.target.value);
        console.log("This is for the selected data types");
        console.log(piiClassificationEvent.target.value);
    };
    // ****************** BEGIN FORM ****************************

    function dataPointForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >

                <Box
                    sx={{ width: 800 , height: 300, pl: 5}}
                    role="presentation"
                >
                    <h1  style={{cursor:'pointer'}}  onClick={() => closeDataPointDrawer()}>Data Point Form</h1>
                    <h4>{selectorDpDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="mcode">Code</InputLabel>
                    <Input sx={{ width: 300 }}
                        {...register('mcode', { required: true })}
                        id="mcode" name="mcode"  label="mcode" aria-describedby="mcode_entry"
                        defaultValue=        {useSelector((state) => state.dataPointSlc.value.mcode)}
                    />
                    <FormHelperText id="mcode_helper">enter a brief code in all caps</FormHelperText>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="name">Name</InputLabel>
                    <Input
                        {...register('name', { required: true })}
                        id="name"   name="name"  label="Name" aria-describedby="name_entry"
                        defaultValue=        {useSelector((state) => state.dataPointSlc.value.name)}
                        sx={{ width: 600 }} />
                    <FormHelperText id="name_helper">enter the name of the Data Point</FormHelperText>
                    <br/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="description">Description</InputLabel>
                    <Input
                        {...register('description', { required: false })}
                        id="description" name="description"  label="description" aria-describedby="description_entry"
                        defaultValue=        {useSelector((state) => state.dataPointSlc.value.description)}
                        sx={{ width: 700 }}/>
                    <FormHelperText id="description_helper">enter a description of the Data Point</FormHelperText>
                    <br/>
                    <br/>
                    <br/>
                    <Stack direction="row" spacing={12}>
                    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
                        <InputLabel htmlFor="dataType">Data Type</InputLabel>
                        <Select
                            sx={{ width: 200 }}
                            {...register('dataType', { required: true })}
                            labelId="dataType"
                            id="dataType"
                            // value={selectedValue}
                            label="dataType"
                            onChange={handleDataTypeChange}
                            defaultValue=        {useSelector((state) => state.dataPointSlc.value.dataType)}
                        >
                            {dataType.map((dataType) =>
                                <MenuItem value={dataType.mcode}>{dataType.name}</MenuItem>
                            )}
                        </Select>
                        <FormHelperText id="data_type_helper">select the Data Type</FormHelperText>
                    </FormControl>
                    <Box>
                        <Checkbox
                            checked={allowMany}
                            onClick={() => setAllowMany(!allowMany)}
                            {...register('allowMany', {required: false})}
                            id="allowMany" name="allowMany" label="allowMany"
                            defaultValue=        {useSelector((state) => state.dataPointSlc.value.allowMany)}
                            aria-describedby="allowMany_entry"
                            //          defaultValue=        {selectorCdpvAllowMany}
                            sx={{width: 200}}/>
                        <FormHelperText id="allowMany_helper">a contract can have more than one (rare)</FormHelperText>
                    </Box>
                    </Stack>
                    <br/>
                    <br/>
                    <Button
                        type= "submit"
                    >Submit</Button>
                    <Button onClick={() => closeDataPointDrawer()}>Cancel</Button>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorDpDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointDrawer}
            >
                {dataPointForm()}
            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
